import * as React from 'react';
import { GridContainerWrapper } from './styles.js';
import { GridContainerAlignment, GridContainerSpacing } from './types.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GridContainer = function GridContainer(_ref) {
  var _ref$alignGrid = _ref.alignGrid,
      alignGrid = _ref$alignGrid === void 0 ? GridContainerAlignment.Center : _ref$alignGrid,
      _ref$isFixed = _ref.isFixed,
      isFixed = _ref$isFixed === void 0 ? true : _ref$isFixed,
      _ref$columnGutter = _ref.columnGutter,
      columnGutter = _ref$columnGutter === void 0 ? GridContainerSpacing.Large : _ref$columnGutter,
      _ref$externalMargin = _ref.externalMargin,
      externalMargin = _ref$externalMargin === void 0 ? GridContainerSpacing.XxxLarge : _ref$externalMargin,
      _ref$externalMarginMo = _ref.externalMarginMobile,
      externalMarginMobile = _ref$externalMarginMo === void 0 ? GridContainerSpacing.Large : _ref$externalMarginMo,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["alignGrid", "isFixed", "columnGutter", "externalMargin", "externalMarginMobile", "children"]);

  return /*#__PURE__*/React.createElement(GridContainerWrapper, _extends({
    alignGrid: alignGrid,
    isFixed: isFixed,
    columnGutter: columnGutter,
    externalMargin: externalMargin,
    externalMarginMobile: externalMarginMobile
  }, props), children);
};

GridContainer.Alignments = GridContainerAlignment;
GridContainer.Spacing = GridContainerSpacing;

export { GridContainer as default };
